'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _submitPql = require('ui-addon-upgrades/_core/pql/submitPql');

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _ContactSalesPropsInterface = require('ui-addon-upgrades/_core/contactSales/ContactSalesPropsInterface');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _CommunicationMethodsPrompt = require('ui-addon-upgrades/_core/communicationMethods/CommunicationMethodsPrompt');

var _salesPhoneNumbers = require('ui-addon-upgrades/_core/common/constants/salesPhoneNumbers');

var _salesPhoneNumbers2 = _interopRequireDefault(_salesPhoneNumbers);

var _MeetingPrompt = require('ui-addon-upgrades/_core/communicationMethods/MeetingPrompt');

var _meetingLinks = require('../common/constants/meetingLinks');

var _meetingHelpers = require('ui-addon-upgrades/_core/common/api/meetingHelpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BUTTON_STATUSES = (0, _keyMirror2.default)({
  INITIAL: null,
  LOADING: null,
  SUCCESS: null
});

var CLICK_DELAY = 50;

function sequence() {
  for (var _len = arguments.length, handlers = Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(undefined, args);
    });
  };
}

var ContactSalesButton = function (_React$Component) {
  _inherits(ContactSalesButton, _React$Component);

  function ContactSalesButton(props) {
    _classCallCheck(this, ContactSalesButton);

    var _this = _possibleConstructorReturn(this, (ContactSalesButton.__proto__ || Object.getPrototypeOf(ContactSalesButton)).call(this, props));

    _this.state = {
      buttonStatus: BUTTON_STATUSES.INITIAL
    };

    _this.debouncedHandleClick = (0, _underscore.debounce)(_this.handleClick.bind(_this), CLICK_DELAY);
    return _this;
  }

  _createClass(ContactSalesButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          upgradeData = _props.upgradeData,
          termId = _props.termId,
          additionalUnitQuantity = _props.additionalUnitQuantity;


      tracker.track('contactSalesButtonInteraction', _extends({
        action: 'viewed'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));
    }
  }, {
    key: 'handleContactSales',
    value: function handleContactSales() {
      var _this2 = this;

      var _props2 = this.props,
          upgradeData = _props2.upgradeData,
          allowModal = _props2.allowModal,
          termId = _props2.termId,
          additionalUnitQuantity = _props2.additionalUnitQuantity,
          onCancel = _props2.onCancel,
          _overrideCommunicationMethodKey = _props2._overrideCommunicationMethodKey,
          _overrideModalHeaderText = _props2._overrideModalHeaderText;


      tracker.track('contactSalesButtonInteraction', _extends({
        action: 'clicked'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));

      var pqlData = _extends({}, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      });

      if (allowModal) {
        (0, _submitPql.submitPql)(pqlData);
        (0, _CommunicationMethodsPrompt.CommunicationMethodsPrompt)(_extends({
          upgradeData: upgradeData,
          onCancel: onCancel
        }, _overrideCommunicationMethodKey && {
          _overrideCommunicationMethodKey: _overrideCommunicationMethodKey
        }, _overrideModalHeaderText && {
          _overrideModalHeaderText: _overrideModalHeaderText
        }));
        return;
      }

      this.setState({ buttonStatus: BUTTON_STATUSES.LOADING });

      (0, _submitPql.submitPql)(pqlData).then(function () {
        _this2.setState({ buttonStatus: BUTTON_STATUSES.SUCCESS });
      });
    }
  }, {
    key: 'handleContactIsc',
    value: function handleContactIsc() {
      var _props3 = this.props,
          upgradeData = _props3.upgradeData,
          termId = _props3.termId,
          additionalUnitQuantity = _props3.additionalUnitQuantity,
          onCancel = _props3.onCancel;
      var repInfo = upgradeData.repInfo;


      var linkBase = repInfo && repInfo.link ? repInfo.link : _meetingLinks.ISC_CALENDAR_LINK;
      var meetingLink = linkBase + '?' + (0, _meetingHelpers.getInlineMeetingParams)(upgradeData);

      tracker.track('contactSalesButtonInteraction', _extends({
        action: 'clicked talk to ISC'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));

      (0, _MeetingPrompt.MeetingPrompt)({ meetingLink: meetingLink, upgradeData: upgradeData, onCancel: onCancel });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      return this.props.contactIsc ? this.handleContactIsc() : this.handleContactSales();
    }
  }, {
    key: 'renderSuccess',
    value: function renderSuccess() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.contactSalesButton.success' })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.contactSalesButton.callNow' })
        ),
        _react2.default.createElement(
          'h4',
          null,
          _salesPhoneNumbers2.default.DEFAULT
        )
      );
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return _react2.default.createElement(
        'div',
        {
          style: {
            width: '150px',
            textAlign: 'center',
            display: 'inline-block'
          }
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'inline-block'
            }
          },
          _react2.default.createElement(_UILoadingSpinner2.default, null)
        )
      );
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var _props4 = this.props,
          onClick = _props4.onClick,
          forwardedRef = _props4.forwardedRef,
          _buttonOverride = _props4._buttonOverride;

      var onClickSequence = sequence(this.debouncedHandleClick, onClick);

      var propsToPass = (0, _underscore.omit)(this.props, ['forwardedRef', 'onClick', 'upgradeData', 'allowModal', 'contactIsc', 'termId', 'additionalUnitQuantity', '_textOverride', '_overrideCommunicationMethodKey', '_buttonOverride', '_overrideModalHeaderText']);

      var buttonText = this.props._textOverride || _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.contactSalesButton.text' });

      // For use cases that require a different component than a UIButton
      if (_buttonOverride) {
        return _react2.default.createElement(
          'div',
          {
            onClick: onClickSequence,
            'data-selenium': 'contact-sales-button',
            'data-reagan-primary-cta': true
          },
          _buttonOverride
        );
      }

      return _react2.default.createElement(
        _UIButton2.default,
        _extends({
          buttonRef: forwardedRef,
          onClick: onClickSequence
        }, propsToPass, {
          'data-selenium': 'contact-sales-button',
          'data-reagan-primary-cta': true
        }),
        buttonText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonStatus = this.state.buttonStatus;


      if (buttonStatus === BUTTON_STATUSES.SUCCESS) {
        return this.renderSuccess();
      }

      if (buttonStatus === BUTTON_STATUSES.LOADING) {
        return this.renderLoading();
      }

      return this.renderButton();
    }
  }]);

  return ContactSalesButton;
}(_react2.default.Component);

ContactSalesButton.defaultProps = {
  use: 'primary',
  onClick: function onClick() {},
  allowModal: true,
  contactIsc: false, // For unassigned users to be able to meet with ISCs, rather than sales reps
  _textOverride: null,
  _buttonOverride: null,
  _overrideCommunicationMethodKey: null,
  _overrideModalHeaderText: null
};

ContactSalesButton.propTypes = _extends({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _ContactSalesPropsInterface.ContactSalesButtonPropsInterface, {
  _textOverride: _react.PropTypes.node,
  onClick: _react.PropTypes.func,
  _overrideCommunicationMethodKey: _react.PropTypes.string,
  _buttonOverride: _react.PropTypes.node,
  _overrideModalHeaderText: _react.PropTypes.node
});

exports.default = ContactSalesButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/contactSales/ContactSalesButton.js
// module id = 550
// module chunks = 3 4 5